import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const CheckoutCancel = () => {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4 md:px-8 py-16" data-testid="checkout-cancel-page">
            <div className="max-w-2xl w-full border-4 border-ink p-8 md:p-12 bg-ink text-center">
                <XCircle className="w-12 h-12 mx-auto mb-4" />
                <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-hazard">
                    [Checkout Cancelled]
                </span>
                <h1 className="font-heading text-5xl md:text-7xl uppercase mt-2">
                    Pulled Back.
                </h1>
                <p className="mt-3 text-sm">
                    No worries — your bag is still saved. Come back when you&apos;re ready.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                    <Link
                        to="/cart"
                        className="bg-ink text-black border-2 border-ink px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.25em] hover:bg-hazard hover:border-hazard"
                        data-testid="cancel-back-to-cart"
                    >
                        Back To Bag
                    </Link>
                    <Link
                        to="/shop"
                        className="border-2 border-ink px-8 py-4 font-mono-ui text-xs uppercase tracking-[0.25em] hover:bg-ink hover:text-black"
                        data-testid="cancel-shop-link"
                    >
                        Keep Browsing
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CheckoutCancel;
